function bindStatusSelect () {
  $('.select2-status').on('change', function (e) {
    const contractTemplateId = e.target.id.replace('ContractTemplate_', '')
    const contractTemplatePath = window.location.pathname.replace(/\/+$/, '') + '/' + contractTemplateId + '.json'
    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    fetch(contractTemplatePath, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ contract_template: { status: e.target.value } })
    })
  })
}

window['contract_templates#index'] = bindStatusSelect
window['units/contract_templates#index'] = bindStatusSelect
